module.exports = __webpack_public_path__ + "img/MX.5b0f1c76.png";